import { createSlice } from '@reduxjs/toolkit';
import { chat } from './chat';
import axiosServices from 'utils/axios';
import { ReportsProps } from 'types/reports';
const url = process.env.REACT_APP_API_URL;

export const initialState: ReportsProps = {
  reportStatusAttendances: null,
  finalizedReasons: null,
  metricsOperatorAttendances: null,
  totalStatusQueue: null,
  totalReasonsTypes: []
};

const joinArrayIfExists = (array: any[] | undefined, key: string) => {
  if (array && Array.isArray(array) && array.length > 0) {
    return { [key]: array.join(',') };
  }
  return {};
};

const reports = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReportStatusAttendances(state, action) {
      state.reportStatusAttendances = action.payload;
    },
    setFinalizedReasons(state, action) {
      state.finalizedReasons = action.payload;
    },
    setMetricsOperatorAttendances(state, action) {
      state.metricsOperatorAttendances = action.payload;
    },
    setTotalStatusQueue(state, action) {
      state.totalStatusQueue = action.payload;
    },
    setTotalReasonsTypes(state, action) {
      state.totalReasonsTypes = action.payload;
    }
  }
});

export function getReportStatusAttendances(dateFrom: Date, dateTo: Date, filters: any) {
  return async (dispatch: any) => {
    const params = new URLSearchParams({
      dateFrom: dateFrom.toISOString(),
      dateTo: dateTo.toISOString(),
      ...joinArrayIfExists(filters.operatorIds, 'operatorIds'),
      ...joinArrayIfExists(filters.channelIds, 'channelIds'),
      ...joinArrayIfExists(filters.departmentIds, 'departmentIds')
    });

    try {
      const response = await axiosServices.get(
        `${url}/api/report-attendance/v1/total-status-attendances?${params.toString()}`
      );

      dispatch(reports.actions.setReportStatusAttendances(response.data));
    } catch (error) {
      dispatch(
        chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar relatório de atendimento')
      );
    }
  };
}

export function getFinalizedReasons(dateFrom: Date, dateTo: Date, filters: any) {
  return async (dispatch: any) => {
    const params = new URLSearchParams({
      dateFrom: dateFrom.toISOString(),
      dateTo: dateTo.toISOString(),
      ...joinArrayIfExists(filters.operatorIds, 'operatorIds'),
      ...joinArrayIfExists(filters.channelIds, 'channelIds'),
      ...joinArrayIfExists(filters.departmentIds, 'departmentIds')
    });

    try {
      const response = await axiosServices.get(
        `${process.env.REACT_APP_API_URL}/api/report-attendance/v1/total-finished-reasons?${params.toString()}`
      );

      dispatch(reports.actions.setFinalizedReasons(response.data));
    } catch (error) {
      dispatch(
        chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar relatório de atendimento')
      );
    }
  };
}

export function getMetricsOperatorAttendances(dateFrom: Date, dateTo: Date, filters: any) {
  return async (dispatch: any) => {
    const params = new URLSearchParams({
      dateFrom: dateFrom.toISOString(),
      dateTo: dateTo.toISOString(),
      ...joinArrayIfExists(filters.operatorIds, 'operatorIds'),
      ...joinArrayIfExists(filters.reasonTypeIds, 'reasonTypeIds'),
      ...joinArrayIfExists(filters.channelIds, 'channelIds'),
      ...joinArrayIfExists(filters.departmentIds, 'departmentIds')
    });

    try {
      const response = await axiosServices.get(
        `${process.env.REACT_APP_API_URL}/api/report-attendance/v1/metrics-operator-attendances?${params.toString()}`
      );

      dispatch(reports.actions.setMetricsOperatorAttendances(response.data));
    } catch (error) {
      dispatch(
        chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar relatório de atendimento')
      );
    }
  };
}

export function getTotalStatusQueue(filters: any) {
  return async (dispatch: any) => {
    const params = new URLSearchParams({
      ...joinArrayIfExists(filters.operatorIds, 'operatorIds'),
      ...joinArrayIfExists(filters.channelIds, 'channelIds'),
      ...joinArrayIfExists(filters.departmentIds, 'departmentIds')
    });
    try {
      const response = await axiosServices.get(
        `${url}/api/report-attendance/v1/total-status-queues?${params.toString()}`
      );

      dispatch(reports.actions.setTotalStatusQueue(response.data));
    } catch (error) {
      dispatch(
        chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar relatório de atendimento')
      );
    }
  };
}

export function getTotalReasonsTypes(dateFrom: Date, dateTo: Date, filters: any) {
  return async (dispatch: any) => {
    const params = new URLSearchParams({
      dateFrom: dateFrom.toISOString(),
      dateTo: dateTo.toISOString(),
      ...joinArrayIfExists(filters.operatorIds, 'operatorIds'),
      ...joinArrayIfExists(filters.reasonTypeIds, 'reasonTypeIds'),
      ...joinArrayIfExists(filters.channelIds, 'channelIds'),
      ...joinArrayIfExists(filters.departmentIds, 'departmentIds')
    });

    try {
      const response = await axiosServices.get(
        `${url}/api/report-attendance/v1/total-finished-reason-types?${params.toString()}`
      );

      dispatch(reports.actions.setTotalReasonsTypes(response.data));
    } catch (error) {
      dispatch(
        chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar relatório de atendimento')
      );
    }
  };
}

export default reports.reducer;
